<template>
    <article class="file-select-field">
        <b-form-input v-model="filter"
                      type="text"
                      :readonly="readonly"
                      placeholder="Search for a file..."
                      @input="fetchFiles"
        />

        <b-row>
            <b-col v-for="file in files"
                    cols="3"
                    class="my-5"
                    :key="file.id">
                <b-img thumbnail
                       fluid
                       :src="file.url"
                       :alt="file.filename"
                       @click="handleInput(file.id)"
                />
            </b-col>
        </b-row>
    </article>
</template>

<script>
    import axios from 'axios'
    import field from '../../Mixins/field'
    import qs from 'qs'

    export default {
        mixins: [field],
        props: {
            name: {},
            label: {}
        },
        data()
        {
            return {
                files: [],
                filter: ''
            }
        },
        created()
        {
            this.fetchFiles()
        },
        methods: {
            async fetchFiles(filter = '')
            {
                try {
                    let {data: result} = await axios.get('/api/files', {
                        params: {
                            filter: {'search' : filter},
                            limit: 10
                        },
                        paramsSerializer: function(params) {
                            return qs.stringify(params, {arrayFormat: 'repeat'})
                        }
                    })
                    this.files = result.data
                } catch (ex) {
                    alert(ex)
                }
            }
        }
    }
</script>
